import { cn } from '../../lib/utils'

function Skeleton({ className }: { className?: string }) {
  return (
    <div className={cn('animate-pulse rounded bg-white/[0.08]', className)} />
  )
}

export function MetricSkeleton({ className }: { className?: string }) {
  return (
    <div className={cn(
      'rounded-lg border border-white/[0.06] bg-[var(--bg-surface,var(--bg-surface))] p-4',
      className,
    )}>
      <Skeleton className="h-3 w-20 mb-3" />
      <Skeleton className="h-7 w-28 mb-2" />
      <Skeleton className="h-3 w-16" />
    </div>
  )
}

export function DashboardSkeleton({ className }: { className?: string }) {
  return (
    <div className={cn('space-y-6', className)}>
      {/* KPI row */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
        {Array.from({ length: 6 }).map((_, i) => (
          <MetricSkeleton key={i} />
        ))}
      </div>
      {/* Chart row */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="rounded-lg border border-white/[0.06] bg-[var(--bg-surface,var(--bg-surface))] p-4">
          <Skeleton className="h-4 w-32 mb-4" />
          <Skeleton className="h-48 w-full" />
        </div>
        <div className="rounded-lg border border-white/[0.06] bg-[var(--bg-surface,var(--bg-surface))] p-4">
          <Skeleton className="h-4 w-32 mb-4" />
          <Skeleton className="h-48 w-full" />
        </div>
      </div>
    </div>
  )
}

export function TableSkeleton({ rows = 8, className }: { rows?: number; className?: string }) {
  return (
    <div className={cn(
      'rounded-lg border border-white/[0.06] bg-[var(--bg-surface,var(--bg-surface))] overflow-hidden',
      className,
    )}>
      {/* Header */}
      <div className="flex items-center gap-4 px-4 py-3 border-b border-white/[0.06]">
        <Skeleton className="h-3 w-24" />
        <Skeleton className="h-3 w-32" />
        <Skeleton className="h-3 w-20" />
        <Skeleton className="h-3 w-16 ml-auto" />
      </div>
      {/* Rows */}
      {Array.from({ length: rows }).map((_, i) => (
        <div
          key={i}
          className="flex items-center gap-4 px-4 py-2.5 border-b border-white/[0.04]"
        >
          <Skeleton className="h-3 w-20" />
          <Skeleton className="h-3 w-40" />
          <Skeleton className="h-3 w-16" />
          <Skeleton className="h-3 w-20 ml-auto" />
        </div>
      ))}
    </div>
  )
}

export function DetailSkeleton({ className }: { className?: string }) {
  return (
    <div className={cn('space-y-4', className)}>
      {/* Header */}
      <div className="flex items-center gap-3">
        <Skeleton className="h-6 w-48" />
        <Skeleton className="h-5 w-20 rounded-full" />
      </div>
      <Skeleton className="h-3 w-64" />
      {/* Fields */}
      <div className="grid grid-cols-2 gap-4 pt-2">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i}>
            <Skeleton className="h-2.5 w-16 mb-1.5" />
            <Skeleton className="h-4 w-28" />
          </div>
        ))}
      </div>
      {/* Content */}
      <Skeleton className="h-40 w-full mt-4" />
    </div>
  )
}
